// 引入vue
import Vue from 'vue'
// 引入element-ui组件和样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 创建vue实例
let _this = new Vue();
// 引用ElementUI
Vue.use(ElementUI);
// 共用方法对象
let commonMethods = {
    /**
     * @function quickSort 快速排序方法
     * @param { Array } arr 
     */
    quickSort(arr) {
        if(arr.length <= 1) {
            return arr;
        }
        let flag = arr.shift(), left = [], right = [];
        for(let i = 0; i < arr.length; i++) {
            if(flag > arr[i]) {
                left.push(arr[i]);
            } else {
                right.push(arr[i]);
            }
        }
        return [...this.quickSort(left), flag, ...this.quickSort(right)];
    },
    /**
     * @function notificationShow 通知消息提醒
     * @param { string } title 标题
     * @param { string } msg 消息提醒内容
     * @param { string } 消息提醒组件偏移量(与顶部距离)
     */
    notificationShow(title, msg, offset) {
        _this.$notify({
            title: title,
            message: msg,
            offset: offset
        });
    },
    /**
     * @function goBack 返回上一页
     */
    goBack() {
        window.history.back();
    },
    /**
     * @function jointPicUrl 拼接图片路径
     * @param { string } url 
     */
    jointPicUrl(url) {
        let isHttp = String(url).slice(0, 4);
        if(isHttp === 'http') {
            return url;
        }
        return 'https://cdn.mvcsky.com/' + url;
    },
    /**
     * @function jointWebUrl() 方法名 补全网址
     * @param { string } url 必传 网址
     */
    jointWebUrl(url) {
        if(url && typeof url === 'string') {
            let isHTTP = url.slice(0, 4);
            if(isHTTP !== 'http') {
                return 'http://' + url;
            }
        }
        return url;
    },
    /**
     * @function getDateYYYYMMDD 获取日期 YYYY-MM-DD
     * @param { number } timer 时间戳
     */
    getDateYYYYMMDD(timer) {
        let t = new Date(timer * 1000);
        let y = t.getFullYear(), m = t.getMonth() + 1, d = t.getDate();
        let res = `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d}`;
        return res;
    },
    /**
     * @function beforeAvatarUpload 图片上传格式大小判断
     */
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
            _this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function beforeVideoUpload 视频上传格式大小判断
     */
    beforeVideoUpload(file) {
        let type_list = ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'];
        const isJPG = type_list.indexOf(file.type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 500;
        if (!isJPG) {
            _this.$message.error('上传的视频只能是 MP4/OGG/AVI 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传的视频大小不能超过 500MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function beforeFileUpload 文件上传格式大小判断
     */
    beforeFileUpload(file) {
        let type_list = ['text/plain', 'application/vnd.ms-excel', 'application/pdf', 
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const isJPG = type_list.indexOf(file.type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
            _this.$message.error('上传的文件只能是 pdf/word/excel/txt 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传的文件大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
    },
};
export default commonMethods


// WEBPACK FOOTER //
// ./src/common/commonMethods.js